import React from 'react'
import { graphql, Link } from 'gatsby'
import { Helmet } from 'react-helmet'
import Layout from '../components/layout'
import Header from '../components/header'

export default ({ data }) => {
  return (
    <Layout>
      <div>
        <Helmet>
          <meta charSet='utf-8' />
          <title>Blog &bull; Tarashish Mishra</title>
          <link rel='canonical' href='https://sunu.in/posts' />
        </Helmet>
        <Header headerText='Blog posts' />
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <div key={node.id}>
            <div className='post'>
              <p>
                <Link to={'/posts' + node.fields.slug}>
                  {node.frontmatter.title}
                </Link>
              </p>
              <p>{node.frontmatter.date}</p>
            </div>
          </div>
        ))}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
          }
          excerpt
        }
      }
    }
  }
`
